import { Skeleton } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  courseName,
  getTodayDate,
  groupByMultiple,
  MuiModalWindow,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import ReportDetails from "./reportDetails";
import ReportItem from "./reportItem";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const DashboardReport = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataViewSource, setDataViewSource] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    let m = context.getStorageByDate("dahboard_course_att_report");
    if (m) updateDataList(m);
    getReport();
  }, []);

  const updateDataList = (dt) => {
    setDataList(dt);
    let m = groupByMultiple(dt, function (obj) {
      return [obj.course];
    });
    let x = m.filter((item, i) => i < 6 && item);
    setDataViewSource(m);
    setDataView(x);
  };

  const getReport = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.MOB.DASHBOARD_DAY_WISE_ATTENDANCE_REPORT)
      .then((res) => {
        if (res["data"].status == "1") {
          context.setStorage(
            "dahboard_course_att_report",
            res.data.data,
            getTodayDate()
          );
          updateDataList(res.data.data);
        }
        setLoader(false);
      });
  };

  const reportClick = (items) => {
    setViewData(items);
    setShowModal(true);
  };

  const showMoreClick = () => {
    if (dataView.length < 7) setDataView(dataViewSource);
    else {
      let x = dataViewSource.filter((item, i) => i < 6 && item);
      setDataView(x);
    }
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg text-uppercase fw-bold">
          Attendance Report{" "}
          <Link
            to="/staff/app/att-report-details"
            className="float-end theme-text"
          >
            View All <ArrowForwardIcon className="ms-1 fs-5" />
          </Link>
        </Card.Header>
        <Card.Body className="p-2">
          {dataList.length < 1 && loader && (
            <div className="px-4">
              <Skeleton.Paragraph lineCount={3} animated />
            </div>
          )}
          <Row>
            {dataView.map((items, i) => {
              let item = items[0];
              return (
                <ReportItem
                  title={courseName(item)}
                  onClick={(e) => reportClick(items)}
                />
              );
            })}
          </Row>
          {dataList.length > 0 && (
            <div className="text-center">
              <Button
                size="sm"
                variant="solid"
                onClick={(e) => showMoreClick()}
              >
                {dataView && dataView.length < 7 ? (
                  <>
                    Show More <KeyboardArrowDownIcon />
                  </>
                ) : (
                  <>
                    Show Less <KeyboardArrowUpIcon />
                  </>
                )}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      <MuiModalWindow
        open={showModal}
        onClose={(e) => setShowModal(false)}
        title={
          viewData && viewData.length > 0
            ? courseName(viewData[0])
            : "Attendance Report"
        }
      >
        <ReportDetails dataSource={viewData} />
      </MuiModalWindow>
    </>
  );
};
export default DashboardReport;
